// extracted by mini-css-extract-plugin
module.exports = {"section":"SearchRightholdersList__section","content":"SearchRightholdersList__content"};